import { useReport } from './hooks/use-context';

export function InitialInfos() {
  const { header, body } = useReport();
  const data = header as any;
  const item = Array.isArray(body) ? body[0] : (body as any);

  const infoSection = item?.sections?.find((s: any) =>
    s.section_name?.toLowerCase()?.includes('informa')
  );

  const getQuestion = (keywords: string[]) => {
    let foundQ: any = null;
    item?.sections?.forEach((section: any) => {
      if (foundQ) return;
      const q = section?.questions?.find((q: any) =>
        keywords.some((k) => q?.name?.toLowerCase()?.includes(k)),
      );
      if (q) foundQ = q;
    });
    return foundQ;
  };

  const getAnswerText = (question: any) => {
    const answer = question?.answers?.[0];
    if (!answer) return '-';
    if (answer.option) return answer.option;
    if (answer.content) return answer.content;
    const nameProp = answer.collection_item?.properties?.find(
      (p: any) => p.name.toLowerCase() === 'name'
    );
    return nameProp?.content || '-';
  };

  const tstQuestion = getQuestion([
    'tst responsável',
    'tst responsavel',
    'participante',
    'colaborador',
    'preenchido por',
  ]);
  const tstName = getAnswerText(tstQuestion);
  const tstCargo = tstQuestion?.answers?.[0]?.collection_item?.properties?.find(
    (p: any) => p.name.toLowerCase() === 'cargo'
  )?.content || '';

  const areaQuestion = getQuestion(['área', 'area']);
  const setorQuestion = getQuestion(['setor']);
  const responsavelArea = getQuestion(['responsável da área', 'responsavel da area']);
  const tipoInspecao = getQuestion(['nome do tst', 'tipo de inspeção', 'tipo de inspecao']);

  const cellStyle = {
    padding: '4px 8px',
    border: '1px solid black',
    textAlign: 'left' as const,
    fontSize: '11px',
    whiteSpace: 'nowrap' as const,
    display: 'flex',
    alignItems: 'center',
  };

  const valueStyle = {
    textAlign: 'center' as const,
    backgroundColor: '#f9f9f9',
    fontSize: '11px',
    whiteSpace: 'normal' as const,
    borderLeft: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  return (
    <div style={{ marginBottom: '8px' }}>
      <div
        style={{
          fontFamily: 'Arial, sans-serif',
          display: 'grid',
          gridTemplateColumns: 'max-content 1fr',
        }}
      >
        <div
          style={{
            backgroundColor: '#e5e5e5',
            fontWeight: 'bold',
            border: '1px solid black',
            borderBottom: 'none',
            padding: '4px',
          }}
        />
        <div
          style={{
            backgroundColor: '#e5e5e5',
            fontWeight: 'bold',
            border: '1px solid black',
            borderBottom: 'none',
            padding: '4px',
            textAlign: 'center',
          }}
        >
          INFORMAÇÕES
        </div>

        <div style={cellStyle}>TIPO DE INSPEÇÃO</div>
        <div style={{ ...cellStyle, ...valueStyle }}>
          {getAnswerText(tipoInspecao) !== '-' ? getAnswerText(tipoInspecao) : (data?.event_type || '-')}
        </div>

        <div style={{ ...cellStyle, borderTop: 'none' }}>TST RESPONSÁVEL</div>
        <div style={{ ...cellStyle, ...valueStyle, borderTop: 'none' }}>
          {tstName !== '-' ? `${tstName}${tstCargo ? ` - ${tstCargo}` : ''}` : '-'}
        </div>

        <div style={{ ...cellStyle, borderTop: 'none' }}>ÁREA</div>
        <div style={{ ...cellStyle, ...valueStyle, borderTop: 'none' }}>
          {getAnswerText(areaQuestion)}
        </div>

        <div style={{ ...cellStyle, borderTop: 'none' }}>SETOR</div>
        <div style={{ ...cellStyle, ...valueStyle, borderTop: 'none' }}>
          {getAnswerText(setorQuestion)}
        </div>

        <div style={{ ...cellStyle, borderTop: 'none' }}>LOCAL</div>
        <div style={{ ...cellStyle, ...valueStyle, borderTop: 'none' }}>
          USINA GOIASA
        </div>

        <div style={{ ...cellStyle, borderTop: 'none' }}>DATA DE INSPEÇÃO</div>
        <div style={{ ...cellStyle, ...valueStyle, borderTop: 'none' }}>
          {data?.event_date_time || '-'}
        </div>

        <div style={{ ...cellStyle, borderTop: 'none' }}>RESPONSÁVEL DA ÁREA</div>
        <div style={{ ...cellStyle, ...valueStyle, borderTop: 'none' }}>
          {getAnswerText(responsavelArea)}
        </div>
      </div>
    </div>
  );
}
